import { render, staticRenderFns } from "./AlegacionesLoteVisor.vue?vue&type=template&id=367e2f96&scoped=true&"
import script from "./AlegacionesLoteVisor.vue?vue&type=script&lang=ts&"
export * from "./AlegacionesLoteVisor.vue?vue&type=script&lang=ts&"
import style0 from "./AlegacionesLoteVisor.vue?vue&type=style&index=0&id=367e2f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367e2f96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VChip,VIcon,VProgressCircular})
